const STORAGE_KEY = "word_wheel_session";

function createSessionId() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = Math.floor(Math.random() * 16);
        const v = c === "x" ? r : ((r % 4) + 8);
        return v.toString(16);
    });
}

export function clearWordWheelSession() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore storage errors */
    }
}

export function getOrCreateWordWheelSession() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed?.sessionId && parsed?.createdAt) {
                return parsed;
            }
        }
    } catch {
        /* ignore corrupt storage */
    }
    const session = {
        sessionId: createSessionId(),
        createdAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    return session;
}

export function getWordWheelSession() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed?.sessionId && parsed?.createdAt) {
            return parsed;
        }
    } catch {
        return null;
    }
    return null;
}
